import { QueryClient } from '@tanstack/react-query';

import { queryClient as globalQueryClient } from '../../../../store/store';
import { QueryFilters } from './keysAndFilters';

type InvalidateOptions = { refetchActiveQueries?: boolean, queryClient?: QueryClient };

export class ProjectMembersQueryInvalidator {
	static invalidateProjectMembers = (
		projectID?: number,
		{ refetchActiveQueries = false, queryClient = globalQueryClient }: InvalidateOptions = {}
	) => {
		queryClient.invalidateQueries( {
			...QueryFilters.forProjectMembers( projectID, { queryType: 'all' } ),
			refetchType: refetchActiveQueries ? 'active' : 'none'
		} );
	}
}
